import { setSharedCtaContent } from '../../shared/shared-cta.js';
import { appendText, getText } from '../../../assets/js/text-renderer';

import './blog.scss';
import '../../shared/cta/cta';
import './components/blog-card';

document.addEventListener('DOMContentLoaded', async () => {
  if (DEVELOPMENT || (window['__PRERENDER_INJECTED'] && window['__PRERENDER_INJECTED'].render_text)) await loadText();
});

async function loadText() {
  const blogData = await getText('blog/landing-blog');
  const entriesData = await getText('blog/blog-entries');
  const blogContent = blogData.stories[0].content;

  setHeroContent(blogContent);
  setBlogCards(entriesData);
  await setSharedCtaContent();

  window.dispatchEvent(new CustomEvent('rendered-text', { detail: 'keywords' }));
  window.dispatchEvent(new CustomEvent('rendered-text', { detail: 'content' }));
}

function setHeroContent(content) {
  appendText(content.blog_hero, 'blog-hero');
  appendText(content.learn_more_btn, 'learn-more-btn');
}

function formatDate(dateString) {
  const date = new Date(dateString);
  const options = { day: '2-digit', month: 'short', year: 'numeric' };
  return date.toLocaleDateString('en-GB', options);
}

function setBlogCards(entries) {
  const blogCards = document.getElementById('blog-cards');
  const cardsHTML = entries.stories
    .map(
      (story) => `
      <custom-blog-card
        author="${story.content.author}"
        date="${formatDate(story.content.date)}"
        img="${story.content.header_image}"
        name="${story.slug}"
        title="${story.content.header_title}">
      </custom-blog-card>`
    )
    .join('');

  blogCards.innerHTML = cardsHTML;
}
